import { Controller } from '@hotwired/stimulus';

// Connects to data-controller="google-form-stars"
export default class extends Controller {
  static targets = ['input', 'group', 'label', 'button'];

  static labels = {
    1: 'Geht besser',
    2: 'Okay',
    3: 'Gut',
    4: 'Sehr gut',
    5: 'Spitze!'
  };

  connect() {
    this.selected = this.hasInputTarget ? this.inputTarget.value : '';
    this.hovered = null;
    this.render();
  }

  select(event) {
    const value = event.params.value;
    this.selected = String(value);
    if (this.hasInputTarget) {
      this.inputTarget.value = this.selected;
      this.inputTarget.dispatchEvent(new Event('change', { bubbles: true }));
    }
    this.hovered = null;
    this.render();
  }

  hover(event) {
    this.hovered = String(event.params.value);
    this.render();
  }

  leave() {
    this.hovered = null;
    this.render();
  }

  render() {
    if (!this.hasButtonTarget) return;

    const active = this.hovered || this.selected;
    const activeNum = Number(active);

    this.buttonTargets.forEach((button) => {
      const value = String(button.dataset.googleFormStarsValueParam);
      const on = active !== '' && Number(value) <= activeNum;
      button.classList.toggle('on', on && !this.hovered);
      button.classList.toggle('hv', Boolean(this.hovered) && Number(value) <= activeNum);
      button.setAttribute('aria-pressed', value === this.selected ? 'true' : 'false');
    });

    if (this.hasGroupTarget) {
      this.groupTarget.classList.toggle('hovering', Boolean(this.hovered));
    }

    if (this.hasLabelTarget) {
      if (this.selected) {
        const label = this.constructor.labels[Number(this.selected)] || '';
        this.labelTarget.textContent = label
          ? `${this.selected}/5 – ${label}`
          : `${this.selected}/5`;
      } else {
        this.labelTarget.textContent = '';
      }
    }
  }
}
